// client/handlePaymentCompletionTask.ts
import { goTo } from "@adornis/router/client/open-href.js";
import { routingState } from "@adornis/router/client/routing-state.js";
import { waitForTaskToComplete } from "@adornis/tasks/tasks.js";
var handlePaymentCompletionTask = async (options) => {
  const taskID = routingState.searchParams.getOnce("task");
  if (!taskID)
    throw new Error("no taskId in the url searchParams, is the task parameter set?");
  try {
    await waitForTaskToComplete(taskID)({});
    goTo(options.successURL);
  } catch (err) {
    goTo(options.failureURL ?? options.successURL);
  }
};
export {
  handlePaymentCompletionTask
};
